<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <div class="form-group form-row" v-if="datasetId">
        <label :for="safeId('fileName')" class="col-sm-4 col-form-label">URL</label>
        <div class="col-sm-8">
          <p><a href="http://results.theuiaa.org/?raw=true" target="_blank">http://results.theuiaa.org/?raw=true</a></p>
          <input type="text" class="form-control" :id="safeId('fileName')" v-model.lazy="fileName">
        </div>
      </div>
      <div class="form-group form-row" v-if="datasetId">
        <label :for="safeId('group')" class="col-sm-4 col-form-label">Group</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('group')" v-model.lazy="group">
        </div>
      </div>
      <div class="form-group form-row">
        <div class="col-sm-8 offset-4">
          <button type="button" class="btn btn-block btn-primary" @click="fetch()">Fetch</button>
        </div>
      </div>
      <div class="alert alert-danger" v-if="errorMessage">
        <p><b>Error:</b> {{ errorMessage }}</p>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('competition')" class="col-sm-4 col-form-label">Competition</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('competition')" v-model.lazy="competition">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('stage')" class="col-sm-4 col-form-label">Stage</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('stage')" v-model.lazy="stage">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('round')" class="col-sm-4 col-form-label">Round</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('round')" v-model.lazy="round">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('groups')" class="col-sm-4 col-form-label">Groups</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('groups')" v-model.lazy="groups">
        </div>
      </div>

      <dataset-table :dataset-id="datasetId"></dataset-table>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <dataset-settings :window-id="windowId" :dataset-id="datasetId"></dataset-settings>
    </window-tab>
  </window>
</template>

<script>
  import { uuid } from '../lib'
  import { windowPropsMixin } from '../mixins'
  import * as mutation from '../store/mutation-types'
  import DatasetSettings from './dataset-settings.vue'
  import DatasetTable from './dataset-table.vue'

  export default {
    name: 'uiaa-results-center-dataset',
    components: {DatasetSettings, DatasetTable},
    mixins: [windowPropsMixin],
    data () {
      return {
        errorMessage: null,
        competition: null,
        stage: null,
        round: null,
        groups: null
      }
    },
    computed: {
      datasetId () {
        return this.$store.getters.windowData(this.windowId).contentId
      },
      dataset () {
        return this.$store.getters.dataset(this.datasetId) || {}
      },
      title () {
        return this.dataset.title || 'Unnamed dataset'
      },
      fileName: {
        get () {
          return this.dataset.fileName || ''
        },
        set (val) {
          this.$store.commit(mutation.DATASET_UPDATE_META, {
            datasetId: this.datasetId,
            fileName: val,
            emit: true
          })
        }
      },
      group: {
        get () {
          return (this.fileName.match(/[?&]group=([^&$]+)/) || [])[1]
        },
        set (val) {
          const old = this.group
          let fileName = this.fileName
          if (fileName.indexOf('group=' + old) < 0) {
            this.fileName = fileName + '?group=' + val
          } else {
            this.fileName = fileName.replace('group=' + old, 'group=' + val)
          }
        }
      }
    },
    mounted () {
      if (this.fileName && (this.dataset.records || []).length === 0) {
        this.fetch()
      }
    },
    methods: {
      fetch () {
        console.log('[uiaa/dataset] fetching data')
        this.errorMessage = null
        const request = new XMLHttpRequest()
        request.open('GET', this.fileName, true)
        request.onload = function (event) {
          if (!event.target) {
            this.errorMessage = 'Unknown error'
            return
          }

          if (event.target.status !== 200) {
            this.errorMessage = event.target.statusText
            return
          }
          const response = JSON.parse(event.target.response)

          this.competition = response['Competition']
          this.stage = response['Stage']
          this.round = response['Round']
          this.groups = response['Groups']

          const headers = this.getHeaders(response)
          const columns = this.mergeColumns(response, headers)
          const records = this.mergeRecords(response, headers, this.groups, this.group)

          this.$store.commit(mutation.DATASET_UPDATE_RECORDS, {
            datasetId: this.datasetId,
            columns: columns,
            records: records.map(record => {
              record.recordId = record.recordId || uuid()
              return record
            }),
            emit: true
          })
        }.bind(this)
        request.onerror = function (event) {
          console.log(event)
          this.errorMessage = JSON.stringify(event)
        }.bind(this)
        request.send()
      },
      getHeaders (response) {
        const rules = {
          'COMPETITOR NAME': 'NAME'
        }
        return response['Header'].map(group => {
          return group.map(each => {
            return rules.hasOwnProperty(each) ? rules[each] : each
          })
        })
      },
      mergeColumns (response, headers) {
        const columns = headers.reduce((columns, header) => {
          // Concat columns with new headers
          return columns.concat(header.filter(each => {
            return columns.indexOf(each) < 0
          }))
        }, this.dataset.columns || [])
        return columns.concat(['SORT_ORDER', 'GROUP'].filter(each => {
          return columns.indexOf(each) < 0
        }))
      },
      getRecords (response, headers, groups) {
        return response['Data'].reduce((result, rows, groupIdx) => {
          return result.concat(rows.map((raw, rowIdx) => {
            const row = {
              'SORT_ORDER': (groupIdx + 1) * 1000 + rowIdx,
              'GROUP': '' + groups[groupIdx]
            }
            headers[groupIdx].forEach((name, idx) => {
              row[name] = raw[idx]
            })
            return row
          }))
        }, [])
      },
      mergeRecords (response, headers, groups, group) {
        const records = this.dataset.records || []
        const newRecords = this.getRecords(response, headers, groups)
        newRecords
          .filter(r => !group || (group && r.GROUP === '' + group))
          .forEach(newRecord => {
            const oldRecord = records.find(r => r.BIB === newRecord.BIB && r.GROUP === newRecord.GROUP)
            if (!oldRecord) {
              records.push(newRecord)
            } else {
              Object.keys(newRecord).forEach(key => {
                oldRecord[key] = newRecord[key] || oldRecord[key]
              })
            }
          })
        return records
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/uiaa-results-center-dataset.vue